/* A Greener Diwali — twinkling stars in every band, sparks rising in the hero, and a fixed copy of the
   section chips that slides in under the header once the hero chips scroll
   away, with the current section highlighted. */
(function () {
  'use strict';
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Shimmer: lots of four-point stars in every band that zoom in, spin and
  // fade out at random times, plus sparks rising in the hero and closing.
  var STAR = '<svg viewBox="0 0 24 24"><path d="M12 0c.9 6.6 4.4 10.4 12 12-7.6 1.6-11.1 5.4-12 12-.9-6.6-4.4-10.4-12-12C7.6 10.4 11.1 6.6 12 0z"/></svg>';
  var onDark = ['#ffffff', '#fffe34', '#ffd1dc', '#ffffff', '#b8ffd4', '#fff7b0'];
  var onLight = ['#ffffff', '#ffffff', '#ff4f8b', '#ffffff', '#ff9a00', '#fff36b'];
  var small = window.innerWidth < 750;
  [].forEach.call(document.querySelectorAll('[data-gd-sparks]'), function (box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    var dark = !!box.closest('.gd-tone--mag'); // hero + closing are dark; product bands are light
    var colours = dark ? onDark : onLight;
    var tw = dark ? (small ? 30 : 60) : (small ? 22 : 44);
    for (var i = 0; i < tw; i++) {
      var t = document.createElement('span');
      t.className = 'gd-tw';
      t.innerHTML = STAR;
      t.style.cssText =
        'left:' + (2 + Math.random() * 96).toFixed(1) + '%;' +
        'top:' + (2 + Math.random() * 96).toFixed(1) + '%;' +
        '--s:' + (12 + Math.random() * (i % 4 === 0 ? 22 : 12)).toFixed(0) + 'px;' +
        '--c:' + colours[i % colours.length] + ';' +
        '--t:' + (2.4 + Math.random() * 2.6).toFixed(1) + 's;' +
        '--d:-' + (Math.random() * 5).toFixed(1) + 's;';
      box.appendChild(t);
    }
    if (calm || !box.closest('.gd-hero, .gd-close')) return;
    for (var j = 0; j < (small ? 12 : 22); j++) {
      var s = document.createElement('span');
      s.className = 'gd-spark';
      s.style.cssText =
        'left:' + (Math.random() * 100).toFixed(1) + '%;' +
        '--s:' + (4 + Math.random() * 5).toFixed(1) + 'px;' +
        '--t:' + (8 + Math.random() * 8).toFixed(1) + 's;' +
        '--d:-' + (Math.random() * 16).toFixed(1) + 's;' +
        '--dx:' + Math.round(Math.random() * 80 - 40) + 'px;';
      box.appendChild(s);
    }
  });

  // Add to cart: a small burst of sparkles from the button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.gd .wc-btn--add, .gd .gd-feat__add button');
    if (!btn || btn.disabled) return;
    var r = btn.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var cols = ['#fffe34', '#ffffff', '#ff5fa2', '#ffb300', '#16d16a'];
    for (var k = 0; k < 16; k++) {
      var p = document.createElement('span');
      var ang = (Math.PI * 2 * k) / 16 + Math.random() * 0.3;
      var dist = 40 + Math.random() * 45;
      p.className = 'gd-pop';
      p.innerHTML = STAR;
      p.style.cssText = 'left:' + cx + 'px;top:' + cy + 'px;' +
        '--s:' + (8 + Math.random() * 10).toFixed(0) + 'px;' +
        '--c:' + cols[k % cols.length] + ';' +
        '--dx:' + Math.round(Math.cos(ang) * dist * 1.6) + 'px;' +
        '--dy:' + Math.round(Math.sin(ang) * dist) + 'px;';
      document.body.appendChild(p);
      setTimeout(function (el) { el.remove(); }, 800, p);
    }
  }, true);

  var chips = document.querySelector('[data-gd-chips]');
  if (!chips || document.querySelector('.gd-chipbar')) return;
  var bar = document.createElement('div');
  bar.className = 'gd-chipbar';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = chips.innerHTML;
  bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
  document.body.appendChild(bar);

  var links = [].slice.call(chips.querySelectorAll('a')).concat([].slice.call(bar.querySelectorAll('a')));
  var targets = [].slice.call(chips.querySelectorAll('a')).map(function (a) {
    return document.querySelector(a.getAttribute('href'));
  });
  // The bit of the store header that is still on screen (it may be sticky)
  var heads = [].slice.call(document.querySelectorAll('header, sticky-header, .header-wrapper, [id$="__header"], [id$="__announcement_bar"]'))
    .filter(function (el) { return !el.closest('.gd'); });

  function headerBottom() {
    var b = 0;
    heads.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height && r.top < 4 && r.bottom > b) b = r.bottom;
    });
    return Math.max(0, b);
  }

  var ticking = false;
  function update() {
    ticking = false;
    var top = headerBottom();
    bar.style.top = top + 'px';
    var past = chips.getBoundingClientRect().bottom < top;
    var closing = document.getElementById('gd-close');
    var beyond = closing && closing.getBoundingClientRect().top < top + 60;
    bar.classList.toggle('is-on', past && !beyond);

    var line = top + bar.offsetHeight + 40;
    var current = -1;
    targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= line) current = i; });
    links.forEach(function (a, i) { a.classList.toggle('is-on', i % targets.length === current); });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update);
  // the store header slides in and out on its own, so re-check now and then
  setInterval(function () { if (!document.hidden) update(); }, 300);
  update();

  // Jump past the header + chip bar instead of under them
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.gd a[href^="#gd-"], .gd-chipbar a[href^="#gd-"]');
    if (!a) return;
    var t = document.querySelector(a.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    var offset = headerBottom() + 56;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - offset + 8, behavior: calm ? 'auto' : 'smooth' });
  });
})();
